import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { routeId: Number, challengeId: String }

  connect() {
  }

  async syncChallenge(event) {
    const button = event.currentTarget
    const originalText = button.innerHTML
    
    // Show loading state
    button.disabled = true
    button.innerHTML = '<i class="zmdi zmdi-refresh zmdi-hc-spin"></i> Sincronizando...'
    
    // Hide "Ver Resultados" button for this challenge during sync
    this.hideResultsButtonForChallenge(this.challengeIdValue)
    
    const eventId = this.getEventId()
    const currentPath = window.location.pathname
    const hasLocale = currentPath.match(/^\/(pt-BR|en)\//)
    const localePrefix = hasLocale ? hasLocale[0] : '/'
    const url = `${localePrefix}events/${eventId}/routes/${this.routeIdValue}/strava_sync/sync`.replace('//', '/')
    const payload = { challenge_id: this.challengeIdValue }
        
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify(payload)
      })
      
      if (!response.ok) {
        this.showMessage('error', `Erro HTTP ${response.status}: Falha na sincronização`)
        button.disabled = false
        button.innerHTML = originalText
        this.showResultsButtonForChallenge(this.challengeIdValue)
        return
      }
      
      const data = await response.json()
      
      if (data.success) {
        this.showMessage('success', data.message)
        this.startStatusPolling(button, originalText)
      } else {
        this.showMessage('error', data.error)
        button.disabled = false
        button.innerHTML = originalText
        this.showResultsButtonForChallenge(this.challengeIdValue)
      }
    } catch (error) {
      this.showMessage('error', 'Erro de conexão ao sincronizar')
      button.disabled = false
      button.innerHTML = originalText
      this.showResultsButtonForChallenge(this.challengeIdValue)
    }
  }

  startStatusPolling(button, originalText) {
    this.pollingInterval = setInterval(async () => {
      try {
        const currentPath = window.location.pathname
        const hasLocale = currentPath.match(/^\/(pt-BR|en)\//)
        const localePrefix = hasLocale ? hasLocale[0] : '/'
        const statusUrl = `${localePrefix}events/${this.getEventId()}/routes/${this.routeIdValue}/strava_sync/status`.replace('//', '/')
        const response = await fetch(statusUrl)
        const data = await response.json()
        
        // Check if this specific challenge finished syncing
        const challenge = data.challenges.find(c => c.strava_id === this.challengeIdValue)
        
        if (challenge && challenge.last_synced_at) {
          this.stopStatusPolling()
          this.showSyncComplete(button, originalText)
        }
      } catch (error) {
        this.stopStatusPolling()
        button.disabled = false
        button.innerHTML = originalText
        this.showResultsButtonForChallenge(this.challengeIdValue)
      }
    }, 3000) // Poll every 3 seconds
  }

  stopStatusPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
      this.pollingInterval = null
    }
  }

  showSyncComplete(button, originalText) {
    button.disabled = false
    button.innerHTML = originalText
    
    // Refresh the page immediately to show updated sync status and new buttons
    window.location.reload()
  }

  showMessage(type, message) {
    // Remove existing alerts to avoid stacking
    document.querySelectorAll('.alert-global').forEach(alert => alert.remove())
    
    // Create alert using the same pattern as the layout
    const alertClass = type === 'success' ? 'alert-success' : 'alert-danger'
    const iconClass = type === 'success' ? 'zmdi-check-circle' : 'zmdi-alert-circle'
    const duration = type === 'success' ? 6000 : 8000
    
    const alertHTML = `
      <div class="alert ${alertClass} alert-dismissible fade show alert-global" role="alert" data-bs-auto-dismiss="${duration}">
        <i class="zmdi ${iconClass} alert-icon" aria-hidden="true"></i>
        ${message}
        <div class="alert-progress"></div>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `
    
    // Find the content area and prepend the alert
    const contentArea = document.querySelector('.content') || document.querySelector('main') || document.body
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = alertHTML
    const alertElement = tempDiv.firstElementChild
    
    contentArea.insertBefore(alertElement, contentArea.firstChild)
    
    // Apply the auto-dismiss functionality (same as vendors.js)
    alertElement.style.setProperty('--alert-duration', `${duration}ms`)
    
    setTimeout(() => {
      if (alertElement.parentNode) {
        // eslint-disable-next-line no-undef
        const bsAlert = new bootstrap.Alert(alertElement)
        bsAlert.close()
      }
    }, duration)
  }

  getEventId() {
    const pathParts = window.location.pathname.split('/')
    const eventIndex = pathParts.indexOf('events')
    const eventId = pathParts[eventIndex + 1]
    return eventId
  }

  hideResultsButtonForChallenge(challengeId) {
    const resultsButtons = document.querySelectorAll(`[data-challenge-id="${challengeId}"]`)
    
    resultsButtons.forEach(button => {
      if (button.href && button.href.includes('results')) {
        button.style.setProperty('display', 'none', 'important')
        button.style.setProperty('visibility', 'hidden', 'important')
        button.style.setProperty('opacity', '0', 'important')
        button.setAttribute('data-sync-hidden', 'true')
      }
    })
  }

  showResultsButtonForChallenge(challengeId) {
    // Find and show "Ver Resultados" button for this specific challenge
    const resultsButtons = document.querySelectorAll(`[data-challenge-id="${challengeId}"][data-sync-hidden="true"]`)
    resultsButtons.forEach(button => {
      if (button.href && button.href.includes('results')) {
        // Restore original display
        button.style.removeProperty('display')
        button.style.removeProperty('visibility')
        button.style.removeProperty('opacity')
        button.removeAttribute('data-sync-hidden')
      }
    })
  }

  disconnect() {
    this.stopStatusPolling()
  }
}